import { Editor, Plugin } from 'grapesjs';

const plugin: Plugin<{}> = (editor: Editor) => {
  const blockManager = editor.BlockManager;

  blockManager.add('header-block', {
    label: 'Header Block',
    category: 'Components',
    content: [
      {
        type: 'header-block',
        attributes: { class: 'header-block' },
        styles: `
            .header-block { box-sizing: border-box; display: flex; flex-direction: column; justify-content: space-between; background: #F7F8F3; width: 100%; padding: 24px 24px 16px; gap: 12px }
            .header-row { display: flex; flex-direction: row; justify-content: space-between; }
          `,
        components: [
          {
            type: 'div',
            attributes: { class: 'header-row' },
            components: [
              {
                type: 'div',
                styles: `.org-block { display: flex; flex-direction: row; gap: 8px; align-items: center; }`,
                attributes: { class: 'org-block' },
                components: [
                  {
                    type: 'block',
                    attributes: { class: 'logo-container' },
                    styles: `.logo-container { width: 26px; height: 26px; }`,
                    components: [{ attributes: { class: 'logo-container' }, type: 'orgLogo' }],
                  },
                  {
                    type: 'variable',
                    attributes: { class: 'typography-org-name' },
                    variable: 'organization',
                    variant: 'orgName',
                  },
                ],
              },
              {
                type: 'div',
                styles: `.document-type-block { display: flex; flex-direction: column; gap: 4px; }`,
                attributes: { class: 'document-type-block' },
                components: [
                  {
                    type: 'variable',
                    attributes: { class: 'typography-heading' },
                    prefix: 'Document #',
                    variable: 'orderNumber',
                    variant: 'heading',
                  },
                  {
                    type: 'variable',
                    styles: `.align-self-right { align-self: flex-end; }`,
                    attributes: { class: 'typography-content align-self-right' },
                    prefix: 'field: ',
                    variable: 'field',
                    variant: 'content',
                  },
                ],
              },
            ],
          },
          {
            type: 'div',
            attributes: { class: 'header-row' },
            components: [
              {
                type: 'div',
                styles: `.contact-block { display: flex; flex-direction: column; gap: 4px; justify-content: flex-end; }`,
                attributes: { class: 'contact-block' },
                components: [
                  {
                    type: 'hide-if-empty-2',
                    variable: 'phoneNumber',
                    components: [
                      {
                        type: 'div',
                        attributes: { class: 'contact-row' },
                        styles: `.contact-row { display: flex; flex-direction: row; gap: 4px; align-items: center; }`,
                        components: [
                          { type: 'icon', icon: 'call' },
                          {
                            type: 'variable',
                            attributes: { class: 'typography-content' },
                            variable: 'phoneNumber',
                            variant: 'content',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: 'hide-if-empty-2',
                    attributes: { class: 'contact-row' },
                    variable: 'email',
                    components: [
                      {
                        type: 'div',
                        attributes: { class: 'contact-row' },
                        styles: `.contact-row { display: flex; flex-direction: row; gap: 4px; align-items: center }`,
                        components: [
                          { type: 'icon', icon: 'mail' },
                          {
                            type: 'variable',
                            attributes: { class: 'typography-content' },
                            variable: 'email',
                            variant: 'content',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                type: 'div',
                styles: `.address-block { display: flex; flex-direction: column; gap: 4px; justify-content: flex-end; }`,
                attributes: { class: 'address-block' },
                components: [
                  {
                    type: 'address',
                    attributes: { class: 'typography-content' },
                    address: 'address',
                    variant: 'content',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  });

  blockManager.add('field-vertical', {
    label: 'Field (vertical)',
    category: 'Components',
    content: [
      {
        type: 'field-block-vert',
        attributes: { class: 'field-block-vert' },
        styles: `.field-block-vert { display: flex; flex-direction: column; gap: 2px; align-items: flex-start; }`,
        components: [
          { type: 'text', content: 'Field:', attributes: { class: 'typography-subheading' }, variant: 'subheading' },
          { type: 'variable', content: 'field', attributes: { class: 'typography-content' }, variant: 'content' },
        ],
      },
    ],
  });

  blockManager.add('field-horizontal', {
    label: 'Field (horizontal)',
    category: 'Components',
    content: [
      {
        type: 'field-block-horz',
        attributes: { class: 'field-block-horz' },
        styles: `.field-block-horz { display: flex; flex-direction: row; gap: 2px; }`,
        components: [
          { type: 'text', content: 'Field:', attributes: { class: 'typography-subheading' }, variant: 'subheading' },
          { type: 'variable', content: 'field', attributes: { class: 'typography-content' }, variant: 'content' },
        ],
      },
    ],
  });

  blockManager.add('section', {
    label: 'Section',
    category: 'Components',
    content: [
      {
        type: 'section-block',
        attributes: { class: 'section-contents' },
        styles: `.section-contents { width: 100%; padding-bottom: 4px; border-bottom: 1px solid #D8D9D7 }`,
        components: [
          {
            type: 'text',
            content: 'SECTION NAME',
            attributes: { class: 'typography-section-heading' },
            variant: 'sectionHeading',
          },
        ],
      },
    ],
  });

  blockManager.add('total-section', {
    label: 'Total Section',
    category: 'Components',
    content: [
      {
        type: 'total-section',
        attributes: { class: 'total-section' },
        styles: `.total-section { width: 100%; display: flex; flex-direction: row; justify-content: flex-end; }`,
        components: {
          type: 'block',
          attributes: { class: 'total-contents' },
          styles: `.total-contents { width: 174px; padding-top: 11px; border-top: 1px solid #667239; display: flex; flex-direction: row; justify-content: space-between; align-items: center; }`,
          components: [
            {
              type: 'div',
              components: [
                {
                  type: 'text',
                  content: 'TOTAL:',
                  attributes: { class: 'typography-total-heading' },
                  variant: 'totalHeading',
                },
              ],
            },
            {
              type: 'div',
              components: [
                { type: 'variable', content: 'total', attributes: { class: 'typography-total' }, variant: 'total' },
              ],
            },
          ],
        },
      },
    ],
  });

  blockManager.add('signature-lines', {
    label: 'Signature Lines',
    category: 'Components',
    content: [
      {
        type: 'section-block',
        attributes: { class: 'signature-section-contents' },
        styles: `.signature-section-contents { width: 100%; padding-bottom: 4px; margin-bottom: 18px; border-bottom: 1px solid #D8D9D7 }`,
        components: [
          {
            type: 'text',
            content: 'SECTION NAME',
            attributes: { class: 'typography-section-heading' },
            variant: 'sectionHeading',
          },
        ],
      },
      {
        type: 'div',
        content: 'signature-contents',
        styles: `.signature-contents { display: flex; flex-direction: column; gap: 16px; }`,
        attributes: { class: 'signature-contents' },
        components: [
          {
            type: 'div',
            styles: `.signature-row { width: 100%; display: flex; flex-direction: row; align-items: center; gap: 4px }`,
            attributes: { class: 'signature-row' },
            components: [
              {
                type: 'div',
                attributes: { class: 'signature-line' },
                styles: `.signature-line { grow: 1; padding-top: 2px; border-top: 1px solid #D8D9D7; display: flex; flex-direction: row; align-items: center; }`,
                components: [
                  {
                    type: 'text',
                    content: 'Name',
                    attributes: { class: 'typography-section-heading' },
                    variant: 'sectionHeading',
                  },
                ],
              },
              {
                type: 'div',
                attributes: { class: 'signature-line' },
                styles: `.signature-line { grow: 1; padding-top: 2px; border-top: 1px solid #D8D9D7; display: flex; flex-direction: row; align-items: center; }`,
                components: [
                  {
                    type: 'text',
                    content: 'Signature',
                    attributes: { class: 'typography-section-heading' },
                    variant: 'sectionHeading',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  });
};

export default plugin;
